import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';
import { ProjectCommodityResponseDto } from '../dto/response/project-commodity-response.dto';
import projectCommodityService from '../services/project-commodity.service';
import { ProjectCommoditySaveRequestDto } from '../dto/request/project-commodity-save-request.dto';
// import { ProjectCommodityUpdateRequestDto } from '../dto/request/project-commodity-update-request.dto';
import { CommodityResponseDto } from '../../commodity/dto/response/commodity-response.dto';

const initialState = {
  status: 'idle',
  projectCommodities: [] as ProjectCommodityResponseDto[] | null,
  projectCommodity: {} as ProjectCommodityResponseDto | null,
  commodities: [] as CommodityResponseDto[] | null,
  error: null as string | null,
};

export const fetchProjectCommoditiesByProjectId = createAsyncThunk(
  'projectCommodity/fetchProjectCommoditiesByProjectId',
  async (id: string) => {
    return await projectCommodityService.fetchProjectCommoditiesByProjectId(id);
  }
);

// export const fetchProjectCommodityById = createAsyncThunk(
//   'projectCommodity/fetchProjectCommodityById',
//   async (id: string) => {
//     return await projectCommodityService.fetchProjectCommodityById(id);
//   }
// );

export const fetchCommoditiesByProjectId = createAsyncThunk(
  'projectCommodity/fetchCommoditiesByProjectId',
  async (id: string) => {
    return await projectCommodityService.fetchCommoditiesByProjectId(id);
  }
);

export const saveProjectCommodity = createAsyncThunk(
  'projectCommodity/saveProjectCommodity',
  async (saveRequest: ProjectCommoditySaveRequestDto) => {
    return await projectCommodityService.saveProjectCommodity(saveRequest);
  }
);

// export const updateProjectCommodity = createAsyncThunk(
//   'projectCommodity/updateProjectCommodity',
//   async (updateRequest: ProjectCommodityUpdateRequestDto) => {
//     return await projectCommodityService.updateProjectCommodity(updateRequest);
//   }
// );

export const deleteProjectCommodity = createAsyncThunk(
  'projectCommodity/deleteProjectCommodity',
  async (existingId: string, { rejectWithValue }) => {
    try {
      await projectCommodityService.deleteProjectCommodity(existingId);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

const projectCommoditySlice = createSlice({
  name: 'projectCommoditySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectCommoditiesByProjectId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchProjectCommoditiesByProjectId.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.projectCommodities = action.payload;
        }
      )
      .addCase(fetchProjectCommoditiesByProjectId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      // .addCase(fetchProjectCommodityById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProjectCommodityById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.projectCommodities = action.payload;
      // })
      // .addCase(fetchProjectCommodityById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })

      .addCase(fetchCommoditiesByProjectId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCommoditiesByProjectId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.commodities = action.payload;
      })
      .addCase(fetchCommoditiesByProjectId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      .addCase(saveProjectCommodity.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveProjectCommodity.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectCommodities?.push(action.payload);
        showSuccess('Project Commodity added successfully.');
      })
      .addCase(saveProjectCommodity.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      // .addCase(updateProjectCommodity.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateProjectCommodity.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   showSuccess('Project Commodity saved successfully.');
      //   if (state.projectCommodities) {
      //     const projectCommodityIndex = state.projectCommodities.findIndex(
      //       (projectCommodity) => projectCommodity.id === action.payload.id
      //     );
      //     if (projectCommodityIndex !== -1) {
      //       state.projectCommodities[projectCommodityIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateProjectCommodity.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })

      .addCase(deleteProjectCommodity.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProjectCommodity.fulfilled, (state) => {
        state.status = 'succeeded';
        showSuccess('Project Commodity deleted successfully.');
      })
      .addCase(deleteProjectCommodity.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(
          `Deleting Project Commodity failed. ${action.payload as string}`
        );
      });
  },
});

export default projectCommoditySlice.reducer;
